import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #0891b2',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function FvgNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const output = data.output || 'present';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#22d3ee' }}>🕳 Fair Value Gap</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={data.direction || 'bullish'} onChange={(e) => onChange('direction', e.target.value)} style={selStyle}>
        <option value="bullish">Bullish (gap up)</option>
        <option value="bearish">Bearish (gap down)</option>
      </select>

      <select value={output} onChange={(e) => onChange('output', e.target.value)} style={selStyle}>
        <option value="present">Fresh FVG Printed (1/0)</option>
        <option value="in_zone">Price In Unfilled FVG (1/0)</option>
      </select>

      {output === 'in_zone' && (
        <>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Lookback (bars)</label>
          <input
            type="number" min={3} value={data.lookback ?? 30}
            onChange={(e) => onChange('lookback', parseInt(e.target.value, 10) || 30)}
            style={selStyle}
          />
        </>
      )}

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        3-bar imbalance. Outputs 1 when detected, else 0. Compare with value 1.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#0891b2' }} />
    </div>
  );
}
